import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import styled from "styled-components";
import { logEvent } from "../../../helpers/tracker";
import { Trans, useTranslation } from "@coworker/locales";
import { useNameFormatter } from "../../../hooks/useNameFormatter";

import { FullWidthButton } from "../../SkapaButton";
import { Container, OverflowBackground } from "../CommonComponents";
import { ChosenTeamBox } from "./ConfirmationBox";

const Separator = styled("div")`
  background-color: var(--grey100);
  height: 16px;
`;

const Margin = styled("div")`
  margin: 24px;
`;

interface ConfirmAssignmentProps {
  teamId: string;
  onClose: () => void;
  onSubmit: (reassign: boolean) => void;
}

/**
 * Resolves (calls onSubmit) with true ONLY when reassign button is pressed
 * All other cases just closes the dialog and returns false or undefined.
 */
export function ConfirmAssignment({
  onClose,
  onSubmit,
  teamId,
}: ConfirmAssignmentProps) {
  const { t } = useTranslation();
  const { teamNameFor } = useNameFormatter();
  const teamName = teamNameFor(teamId);

  const handleChosenTeamBoxClick = () => {
    logEvent("ce:confirm_assignment:blind_click");
    onSubmit(true);
  };

  const handleChangeClick = () => {
    logEvent("ce:confirm_assignment:change");
    onSubmit(true);
  };

  const handleConfirmClick = () => {
    logEvent("ce:confirm_assignment:confirm");
    console.log("handleConfirmClick invoked"); // Debug log
    onClose();
  };

  return (
    <>
      <OverflowBackground
        data-testid="background"
        onClick={() => {
          logEvent("ce:confirm_assignment:close_overflow");
          onClose();
        }}
      />
      <Container data-testid="confirmScreen">
        <FixaModalHeader
          title={t("assignString")}
          closeBtnClick={() => {
            logEvent("ce:confirm_assignment:x");
            onClose();
          }}
        />

        <Margin>
          <ChosenTeamBox text={teamName} onClick={handleChosenTeamBoxClick} />
        </Margin>

        <FullWidthButton
          style={{ margin: "-24px 24px 16px 24px" }}
          type="secondary"
          text={<Trans>changeString</Trans>}
          onClick={handleChangeClick}
        />
        <Separator />
        <FullWidthButton
          text={<Trans>confirmString</Trans>}
          onClick={handleConfirmClick}
        />
      </Container>
    </>
  );
}
